import { type PeriodsState } from '@yodamoda/core'
import { appendPeriodQueryParams } from './url-helpers'

export const AppRoutes = {
  AccountSettings: () => '/account-settings',
  Advertisement: () => '/advertisement',
  Chat: () => '/chat',
  CogsManagement: () => '/cogs-management',
  ConfirmEmail: () => `${AppRoutes.AccountSettings()}/confirm-email`,
  Education: () => '/education',
  EmailPreferences: () => '/email/preferences',
  EmailUnsubscribe: () => '/email/unsubscribe',
  EtsyRadar: () => '/etsy-radar',
  Integrations: () => '/integrations',
  KeywordFinder: () => '/keyword-finder',
  Landing: () => AppRoutes.ProductFinder(),
  Listing: (id: number) => AppRoutes.ListingPattern().replace(':listingId', id.toString()),
  ListingWithPeriod: (id: number, period: PeriodsState) =>
    appendPeriodQueryParams(AppRoutes.Listing(id), period),
  ListingPattern: () => `${AppRoutes.Listings()}/:listingId`,
  Listings: () => '/listings',
  LoadingAccount: () => '/loading-account',
  Login: () => '/login',
  Mcp: () => '/mcp',
  McpAuthorize: () => '/mcp/authorize',
  NoSubscriptionEducation: () => '/learning',
  Orders: () => '/orders',
  Payment: () => '/subscription',
  Product: (id: number) => AppRoutes.ProductPattern().replace(':productId', id.toString()),
  ProductWithPeriod: (id: number, period: PeriodsState) =>
    appendPeriodQueryParams(AppRoutes.Product(id), period),
  ProductCogs: (id: number) => AppRoutes.ProductCogsPattern().replace(':productId', id.toString()),
  ProductCogsPattern: () => `${AppRoutes.CogsManagement()}/:productId`,
  ProductFinder: () => '/product-finder',
  ProductFinderResults: () => '/product-finder/results',
  ProductFinderResultsPattern: () => '/product-finder/results',
  ProductFinderShopListings: (shopId: string) =>
    AppRoutes.ProductFinderShopListingsPattern().replace(':shopId', shopId),
  ProductFinderShopListingsPattern: () => '/product-finder/shops/:shopId/listings',
  ShopFinder: () => '/shop-finder',
  ShopFinderShopListings: (shopId: string) =>
    AppRoutes.ShopFinderShopListingsPattern().replace(':shopId', shopId),
  ShopFinderShopListingsPattern: () => '/shop-finder/shops/:shopId/listings',
  ProductPattern: () => `${AppRoutes.Products()}/:productId`,
  Products: () => '/products',
  ProfitTracking: () => '/profit-tracking',
  ResearchListing: (id: string) => `${AppRoutes.ResearchListings()}/${id}`,
  ResearchListingPattern: () => `${AppRoutes.ResearchListings()}/:listingId`,
  ResearchListings: () => '/research/listings',
  ResearchShop: (id: string) => `${AppRoutes.ResearchShops()}/${id}`,
  ResearchShopPattern: () => `${AppRoutes.ResearchShops()}/:shopId`,
  ResearchShops: () => '/research/shops',
  Settings: () => '/settings',
  Subscription: () => `${AppRoutes.AccountSettings()}/subscription`,
  TrackingKeywords: () => '/tracking-keywords',
  TrackingListings: () => '/tracking-listings',
  TrackingShops: () => '/tracking-shops',
  Upgrade: () => `${AppRoutes.Subscription()}/upgrade`,
  UnsubscribedAccountSettings: () => `${AppRoutes.Payment()}/account-settings`
}
